<div [formGroup]="formGroup()" class="time-range-field">
  <umss-checkbox label="All day" size="Regular" formControlName="allDay" />

  @if (!formGroup().controls['allDay'].value) {
    <div smoothCollapse class="time-fields">
      <div class="time-pickers-row">
        <umss-time-picker
          label="Start time"
          placeholder="HH:mm"
          formControlName="startTime"
          [required]="true"
          [error]="showStartError()"
          [errorMessage]="startErrorMessage()"
          (committed)="onStartTimeCommitted()"
        />

        <umss-time-picker
          #endTimePicker
          label="End time"
          placeholder="HH:mm"
          formControlName="endTime"
          [required]="true"
          [error]="showEndError()"
          [errorMessage]="endErrorMessage()"
        />
      </div>

      @if (formGroup().errors?.['timeRange']) {
        <p class="error-message">Start time must be earlier than end time.</p>
      }
      @if (formGroup().errors?.['sameTime']) {
        <p class="error-message">Start and end time cannot be the same.</p>
      }
    </div>
  }
</div>
